import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";

import systemRoutes from "@/views/system/router";
import globalShare from "@/utils/globalShare";
import store from "@/store";
import _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import { isOfw } from "@/utils/utils";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  //首页
  {
    path: "",
    alias: "/index",
    name: "index",
    component: () => import("@/views/index.vue"),
    meta: {
      index: 1,
    },
  },
  //登陆页
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
    meta: {
      authorize: false,
    },
  },
  {
    name: "flightBooking",
    path: "/mall/flight",
    component: () => import(`@/views/mall/flight/flight.vue`),
    meta: {
      title: "flight",
    },
  },
  {
    path: "/mall/hotel",
    component: () => import(`@/views/mall/hotel/hotel.vue`),
    name: "hotelBooking",
    meta: { title: "hotel" },
  },
  {
    path: "/mall/train",
    component: () => import(`@/views/mall/train/train.vue`),
    name: "trainBooking",
    meta: { title: "train" },
  },
  // 用车首页
  {
    path: "/mall/trafficList",
    component: () => import(`@/views/mall/traffic/trafficList.vue`),
    name: "trafficList",
    meta: { title: "trafficList" },
  },
  {
    path: "/mall/traffic/taxiList",
    name: "taxiList",
    component: () => import(`@/views/mall/traffic/taxiList.vue`),
  },
  {
    path: "/mall/traffic/orderProce",
    name: "orderProce",
    component: () => import(`@/views/mall/traffic/orderProce.vue`),
  },
  {
    path: "/mall/traffic/:code",
    component: () => import(`@/views/mall/traffic/traffic.vue`),
    name: "traffic",
    meta: { title: "traffic" },
  },

  {
    path: "/mall/flight/list",
    name: "flightList",
    component: () => import("@/views/mall/flight/flightList.vue"),
    meta: {
      serviceCode: "flight",
    },
  },
  {
    path: "/mall/hotel/list",
    name: "hotelList",
    component: () => import("@/views/mall/hotel/hotelList.vue"),
    meta: {
      serviceCode: "hotel",
    },
  },
  {
    path: "/mall/train/list",
    name: "trainList",
    component: () => import("@/views/mall/train/trainList.vue"),
    meta: {
      serviceCode: "train",
    },
  },
  {
    path: "/mall/flight/details",
    name: "flightDetails",
    component: () => import("@/views/mall/flight/flightDetails.vue"),
  },
  {
    path: "/mall/hotel/details",
    name: "hotelDetails",
    component: () => import("@/views/mall/hotel/hotelDetails.vue"),
  },
  {
    path: "/mall/train/details",
    name: "trainDetails",
    component: () => import("@/views/mall/train/trainDetails.vue"),
  },
  {
    path: "/mall/flight/ChangeInfos",
    name: "flightChangeInfos",
    component: () => import("@/views/mall/flight/flightChangeInfos.vue"),
  },
  {
    path: "/mall/train/ChangeInfos",
    name: "trainChangeInfos",
    component: () => import("@/views/mall/train/trainChangeInfos.vue"),
  },
  // {
  //   path: "/mall/list",
  //   name: "list",
  //   component: () => import("@/views/mall/modules/list.vue"),
  //   children: [
  //     {
  //       path: "flight",
  //       name: "flightList",
  //       component: () => import("@/views/mall/flight/flightList.vue"),
  //     },
  //     {
  //       path: "hotel",
  //       name: "hotelList",
  //       component: () => import("@/views/mall/hotel/hotelList.vue"),
  //     },
  //     {
  //       path: "train",
  //       name: "trainList",
  //       component: () => import("@/views/mall/train/trainList.vue"),
  //     },
  //   ],
  // },
  {
    path: "/mall/chooseCostCenter",
    name: "chooseCostCenter",
    component: () => import("@/views/mall/modules/chooseCostCenter.vue"),
  },
  {
    path: "/mall/chooseTripIntent",
    name: "chooseTripIntent",
    component: () => import("@/views/mall/modules/chooseTripIntent.vue"),
  },
  {
    path: "/mall/chooseContraryReason",
    name: "chooseContraryReason",
    component: () => import("@/views/mall/modules/chooseContraryReason.vue"),
  },

  {
    path: "/mall/chooseProjectCode",
    name: "chooseProjectCode",
    component: () => import("@/views/mall/modules/chooseProjectCode.vue"),
  },
  {
    path: "/mall/addPassengers",
    name: "addPassengers",
    component: () => import("@/views/mall/modules/addPassengers.vue"),
  },
  {
    path: "/mall/addKeywords",
    name: "addKeywords",
    component: () => import("@/views/mall/modules/addKeywords.vue"),
  },
  {
    path: "/mall/editRole",
    name: "editRole",
    component: () => import("@/views/mall/modules/editRole.vue"),
  },
  {
    path: "/mall/hotel/order",
    name: "order",
    component: () => import("../views/mall/hotel/hotelOrder.vue"),
  },
  {
    path: "/mall/flight/order",
    name: "order",
    component: () => import("../views/mall/flight/flightOrder.vue"),
  },
  {
    path: "/mall/train/order",
    name: "order",
    component: () => import("../views/mall/train/trainOrder.vue"),
  },
  {
    path: "/mall/train/cardTypeInfo",
    name: "cardTypeInfo",
    component: () => import("../views/mall/train/cardTypeInfo.vue"),
  },
  {
    path: "/order/:serve/change",
    name: "change",
    component: () => import("../views/mall/modules/change.vue"),
  },
  {
    path: "/order/:serve/BackTorule",
    name: "BackTorule",
    component: () => import("../views/mall/flight/BackTorule.vue"),
  },
  {
    path: "/order/:serve/frequenterCardFill",
    name: "frequenterCardFill",
    component: () => import("../views/mall/modules/frequenterCardFill.vue"),
  },

  //user
  {
    path: "/user/resetpwd/verifyIdentity",
    name: "verifyIdentity",
    component: () => import("@/views/user/resetpwd/verifyIdentity.vue"),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/user/resetpwd/mobileValidate",
    name: "mobileValidate",
    component: () => import("@/views/user/resetpwd/mobileValidate.vue"),
    meta: {
      authorize: false,
    },
  },
  // {
  //   path: "/user/main",
  //   name: "main",
  //   component: () => import("@/views/system/user/main.vue"),
  // },

  //base
  {
    path: "/selectCity",
    name: "selectCity",
    component: () => import("@/views/modules/selectCity.vue"),
  },
  {
    path: "/selectAirport",
    name: "selectAirport",
    component: () => import("@/views/modules/selectAirport.vue"),
  },
  {
    path: "/webMap",
    name: "webMap",
    component: () => import("@/views/modules/webMap.vue"),
  },
  //order
  {
    path: "/order/myOrder",
    name: "myOrder",
    component: () => import("@/views/order/orderList.vue"),
  },
  {
    path: "/order/details",
    name: "orderDetails",
    component: () => import("@/views/order/orderDetails.vue"),
  },
  {
    path: "/order/list",
    name: "orderList",
    component: () => import("@/views/order/orderList.vue"),
    meta: {
      index: 2,
    },
  },
  {
    path: "/mall/remarks",
    name: "remarks",
    component: () => import("@/views/mall/modules/remarks.vue"),
  },
  {
    path: "/mall/trainAccount",
    name: "trainAccount",
    component: () => import("@/views/mall/modules/trainAccount.vue"),
  },
  {
    path: "/mall/trainFindPassword",
    name: "trainFindPassword",
    component: () => import("@/views/mall/modules/trainFindPassword.vue"),
  },
  {
    path: "/mall/trainAuthorizeAgreement",
    name: "trainAuthorizeAgreement",
    component: () => import("@/views/mall/modules/trainAuthorizeAgreement.vue"),
  },
  {
    path: "/order/change",
    name: "change",
    component: () => import("@/views/mall/modules/change.vue"),
  },
  {
    path: "/order/refund",
    name: "refund",
    component: () => import("@/views/mall/modules/refund.vue"),
  },

  {
    path: "/trade/cashier",
    name: "cashier",
    component: () => import("@/views/trade/cashier.vue"),
  },
  {
    path: "/trade/paySucc",
    name: "paySuccess",
    component: () => import("@/views/trade/paySucc.vue"),
  },
  // ----------------------------------------------外出申请主页
  {
    path: "/btrip/homePage",
    name: "homePage",
    component: () => import("@/views/btrip/homePage.vue"),
  },
  {
    path: "/btrip/applicationForm",
    name: "applicationForm",
    component: () => import("@/views/btrip/applicationForm.vue"),
  },
  {
    path: "/btrip/applicationList",
    name: "applicationList",
    component: () => import("@/views/btrip/applicationList.vue"),
  },
  {
    path: "/btrip/applicationForm/project/list",
    name: "projectList",
    component: () => import("@/views/btrip/components/projectList.vue"),
  },
  {
    path: "/btrip/applicationForm/card/details",
    name: "cardDetails",
    component: () => import("@/views/btrip/components/cardDetails.vue"),
  },
  {
    path: "/btrip/applicationForm/card/modify",
    name: "cardModify",
    component: () => import("@/views/btrip/components/cardModify.vue"),
  },

  { path: "*", name: "NotFound", component: () => import("@/views/NotFound.vue") }, //全不匹配的情况下，返回404
  ...systemRoutes,
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
function checkState(store: any, to: Route, authorize: boolean, callback: any) {
  if (isOfw()) {
    sessionStorage.setItem("SfsSes", "05abe8412bb3c2cd4766cf4b904aca0c");
  }

  let toLogin = authorize;
  if (document.cookie.indexOf("SfsSes") == -1 && !sessionStorage.getItem("SfsSes")) {
    callback(authorize);
    return;
  } else if (store.getters.profile.UserID !== undefined) {
    callback(false);
    return;
  }
  return store
    .dispatch("reload", {
      failTips: false,
    })
    .then((response: any) => {
      if (response.isSucc === true) {
        if (toLogin) callback(false);
        return response;
      }
      if (isOfw()) {
        callback(false);
        return;
      }
      return store.dispatch("signOut").then(() => callback(toLogin));
    })
    .catch((response: any) => callback(toLogin));
}

function indexSurvey(to: Route) {
  if (!dataShare.realIndex) {
    dataShare.realIndex = history.length;
  } else {
    setTimeout(() => {
      let before = history.length;
      history.pushState({ indexSurvey: "indexSurvey" }, "index", "/");
      let distance = dataShare.realIndex - history.length;
      console.log(`index:${dataShare.realIndex} before:${before} survey:${history.length} distance:${distance}`);
      dataShare.indexSurvey = true;
      history.go(distance);
    }, 0);
  }
}
router.beforeEach((to: Route, from: Route, next: any) => {
  let isBack = globalShare.isBack;
  globalShare.isDestroy = isBack === true;
  globalShare.isBack = false;
  if (isBack === true || isBack === false) {
    if (to.meta && to.meta.index && from.meta && from.meta.index) {
      globalShare.transitionCode = to.meta.index < from.meta.index ? "slide-right" : "slide-left";
    } else {
      globalShare.transitionCode = isBack ? "slide-right" : "slide-left";
    }
  }
  let deviceInfo = localStorage.deviceInfo ? localStorage.deviceInfo : undefined;
  if (to.path == "/" && (!deviceInfo || deviceInfo == "{}")) {
    localStorage.setItem("deviceInfo", JSON.stringify(to.query));
  }
  if (to.path == "/" || to.name == "index") {
    indexSurvey(to);
  }

  let authorize = to.meta === undefined || to.meta.authorize === undefined || to.meta.authorize === true;
  if (!authorize) {
    next();
    return;
  }

  checkState(store, to, authorize, (toLogin: boolean) => {
    if (toLogin !== true) {
      next();
      return;
    }
    next({
      path: "/login",
      query: {
        redirect: to.fullPath,
      },
    });
  });
});

export default router;
